/**
 * S3 bucket naming rule, shared by create + rename so both reject the same names
 * before the round-trip. 3–63 chars, lowercase letters, digits, dots and
 * hyphens, must start/end alphanumeric, no consecutive dots. Mirrors the backend.
 */
const BUCKET_RE = /^[a-z0-9][a-z0-9.-]{1,61}[a-z0-9]$/;

export function validateBucketName(name: string): string | null {
  if (!name) return 'Bucket name is required.';
  if (!BUCKET_RE.test(name)) {
    return 'Use 3–63 lowercase letters, digits, dots or hyphens; start and end alphanumeric.';
  }
  if (name.includes('..')) return 'Bucket name cannot contain consecutive dots.';
  return null;
}
